'use client'
import { ComponentType, FC, PropsWithChildren, useEffect } from 'react'
import { AppLayout } from '@/root/modules/tuuleliinid'
import { SelectDateTimeContent } from '@/root/modules/tuuleliinid/SelectDateTimePage'
import { BookingContainer } from '@/root/components/tuuleliinid'
import { Inventory, SailContent, SailPackage } from '@/root/shared-types'
import { SailParam } from '@/root/modules/shared/SelectDateTimePage'
import { useGetTranslations, useErrorBanner } from '@/root/shared-hooks'
import { Banner } from '@/root/ui/tuuleliinid'
import { ApiError } from '@/root/shared-types/api/ApiError'

export interface SelectDateAndTimePageProps {
  inventory: Inventory[]
  routeBaseInfo: SailPackage
  sailContent: SailContent[][]
  sailParams: SailParam[]
  error?: ApiError
  /** The page frame. The TL header and footer by default; the trial theme passes its unbranded one. */
  Layout?: ComponentType<PropsWithChildren>
}

export const SelectDateAndTimePage: FC<SelectDateAndTimePageProps> = ({
  inventory,
  sailContent,
  routeBaseInfo,
  sailParams,
  error,
  Layout = AppLayout,
}) => {
  const { errorBody, errorHandler, clearError } = useErrorBanner()
  const { getTranslation } = useGetTranslations()

  useEffect(() => {
    if (!errorHandler) return

    if (!error) {
      clearError?.()
      return
    }

    const message = [
      getTranslation('commonNotificationErrorDesc'),
      `${getTranslation('errorRedCodePrefix')} ${error.id ?? error.code}`,
    ].join(' ')

    errorHandler({
      error,
      time: new Date(),
      message,
    })
  }, [error, errorHandler, getTranslation, clearError])

  return (
    <Layout>
      <BookingContainer>
        {errorBody && (
          <Banner title={getTranslation('commonNotificationError')} variant="error" className="my-6 border-0">
            <p className="font-normal whitespace-pre-line">{errorBody}</p>
          </Banner>
        )}

        <SelectDateTimeContent
          routeBaseInfo={routeBaseInfo}
          sailParams={sailParams}
          inventory={inventory}
          sailContent={sailContent}
        />
      </BookingContainer>
    </Layout>
  )
}
